import _ from 'lodash';
import React from 'react';
import {submit, isInvalid, isSubmitting, change} from 'redux-form';

import {
  MODALS,
  KYC_SECTION_TYPES,
  KYC_SECTIONS_META,
  selectSelectedKycId
} from 'ducks/bookings';
import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {Navigation, RequestKycDocumentForm} from './components';

import './styles.css';

class RequestKycDocumentModal extends React.Component<any, any> {
  state: {selectedSectionType: any} = {selectedSectionType: null};

  getDefaultTitle = selectedSectionType => {
    let sectionName: any = null;

    if (selectedSectionType === KYC_SECTION_TYPES.POID)
      sectionName = 'proof of ID';

    if (selectedSectionType === KYC_SECTION_TYPES.POA)
      sectionName = 'proof of address';

    if (selectedSectionType === KYC_SECTION_TYPES.VISA) sectionName = 'VISA';

    return `Additional ${sectionName} document required.`;
  };

  setDefaultTitle = () =>
    this.props.change(
      'requestKycDocument',
      'title',
      this.getDefaultTitle(this.state.selectedSectionType)
    );

  changeSelectedSectionType = selectedSectionType =>
    this.setState({selectedSectionType}, this.setDefaultTitle);

  componentDidMount() {
    const {selectedSectionType} = this.props.data;

    this.setState({selectedSectionType}, this.setDefaultTitle);
  }

  submitForm = () => this.props.submit('requestKycDocument');

  getExtraActions = () => [
    ...this.props.closeModalExtraActions,
    () => this.props.fetchKycDetails(this.props.data.kycId)
  ];

  render() {
    const {
      closeModal,
      data: {bookingId, kycSectionsIds, kycId, form: {submitting, invalid}}
    } = this.props;
    const {selectedSectionType} = this.state;
    const verboseName = _.get(
      KYC_SECTIONS_META[selectedSectionType],
      'VERBOSE'
    );

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.EXTRA_SMALL}
        className="RequestKycDocumentModal">
        <Modal.Header heading="Request KYC Document" />
        <Modal.Body>
          <Navigation
            changeSelectedSectionType={this.changeSelectedSectionType}
            selectedSectionType={selectedSectionType}
          />
          <RequestKycDocumentForm
            selectedSectionType={selectedSectionType}
            getExtraActions={this.getExtraActions}
            kycId={kycId}
            bookingId={bookingId}
            kycSectionsIds={kycSectionsIds}
            openConfirmationModal={this.props.openConfirmationModal}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            blue
            className="submit"
            isLoading={submitting}
            onClick={this.submitForm}
            disabled={submitting || invalid}>
            Send {verboseName} Request
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = state => ({
  kycId: selectSelectedKycId(state),
  form: {
    invalid: isInvalid('requestKycDocument')(state),
    submitting: isSubmitting('requestKycDocument')(state)
  }
});

const mapDispatchToProps = {submit, change};

export default withModal(
  MODALS.REQUEST_KYC_DOCUMENT,
  mapStateToModalData,
  mapDispatchToProps
)(RequestKycDocumentModal);
